import script from "./VitaVacationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaVacationItem.vue?vue&type=script&setup=true&lang=ts"

import "./VitaVacationItem.vue?vue&type=style&index=0&id=5b86b239&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b86b239"]])

export default __exports__